import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import SubjectOverview from "PlanningInsights/routes/CurriculumMapsElements/routes/SubjectOverview";
import StandardsElement from "PlanningInsights/routes/CurriculumMapsElements/routes/StandardsElement";
import SubjectTimeline from "PlanningInsights/routes/CurriculumMapsElements/routes/SubjectTimeline";
export default store => ({
  path: "subjectOverview/:subjectId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(
          /* webpackChunkName: "planning-insights" */ "PlanningInsights/routes/CurriculumMapsElements/components"
        ),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    StandardsElement(store),
    SubjectOverview(store),
    SubjectTimeline(store),
  ],
});
